// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BasicCard_wrapper__22FCT","content":"BasicCard_content__LNuJ1","title":"BasicCard_title__bjob9"};